import { client } from "api";
import { OrderIncompleteReason } from "models/OrderIncompleteReason";

export type GetAllReasonsRequest = { archived?: boolean | null } | undefined;

export type GetAllReasonsResponse = OrderIncompleteReason[];

export const getAllReasons = ({ archived }: GetAllReasonsRequest = {}) =>
  client.get<GetAllReasonsResponse>(`/order-incomplete-reasons`, { params: { archived } }).then((res) => res.data);
